import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';

const ProtectedRoutes = (props) => {
  const userToken = localStorage.getItem('token');
  return userToken ? <Outlet /> : <Navigate to='/auth/login' />;
};

export default ProtectedRoutes;
